import { ReactComponent as TrashIcon } from "../../../../assets/img/icons/trash.svg";
import { useTranslation } from "react-i18next";

export default function DeleteItemButton({ onClick, className }) {
  const { t } = useTranslation();
  return (
    <button className={`${className} flex flex-row`} onClick={onClick}>
      <TrashIcon className="self-center w-6 h-6" />{" "}
      <span className="text-base self-center">{t("registrationsPage.actions.delete")}</span>
    </button>
  );
}
